import { env } from '@/env';

/**
 * Turn an asset path the API hands back into one the browser can load.
 *
 * The backend returns logo URLs as root-relative API paths
 * (`/api/institution/{id}/logo/full`), which is only directly loadable when the app and the API
 * share an origin — true in dev, where `VITE_API_BASE_URL` is `/api` and the Vite proxy forwards
 * it, and false in every deployed build, where the variable is the backend origin and a bare
 * `/api/...` would resolve against the front-end domain instead.
 *
 * `bootstrapApiClient` performs the same normalisation for axios; this is its equivalent for URLs
 * that go into `src` attributes rather than through the HTTP client.
 *
 * An absolute URL is returned untouched, so a backend that later serves logos from a CDN needs no
 * change here.
 */
export function apiAssetUrl(path: string | null | undefined): string | undefined {
  if (path === null || path === undefined || path.trim() === '') return undefined;
  if (/^https?:\/\//i.test(path)) return path;

  const origin = env.VITE_API_BASE_URL.replace(/\/api\/?$/, '');
  return `${origin}${path.startsWith('/') ? '' : '/'}${path}`;
}
